module.exports = "/build/web/svg/event/wvhj-pec.0fdae5fc730c314d4a583a6ddeea7f89.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/event/wvhj-pec.svg
// module id = 164
// module chunks = 24